import React from 'react'

import { applyStyle, getSmartSize } from '../helpers/styles'
import { firstNotUndefined } from '../helpers/null'

const SIZES = {
  xsmall: 0.6,
  small: 0.8,
  normal: 1,
  medium: 1.25,
  large: 2,
  xlarge: 3,
  xxlarge: 4
}

export const useMarginStyle = props => {
  let { noMargin, margin, marginLeft, marginRight, marginBottom, marginTop, marginV, marginH } = props

  marginLeft = !noMargin && firstNotUndefined(marginLeft, marginH, margin)
  marginRight = !noMargin && firstNotUndefined(marginRight, marginH, margin)
  marginTop = !noMargin && firstNotUndefined(marginTop, marginV, margin)
  marginBottom = !noMargin && firstNotUndefined(marginBottom, marginV, margin)

  return React.useMemo(() => {
    return `
      ${applyStyle('margin-left', marginLeft, getSmartSize(marginLeft, SIZES))}
      ${applyStyle('margin-right', marginRight, getSmartSize(marginRight, SIZES))}
      ${applyStyle('margin-top', marginTop, getSmartSize(marginTop, SIZES))}
      ${applyStyle('margin-bottom', marginBottom, getSmartSize(marginBottom, SIZES))}
    `
  }, [marginLeft, marginRight, marginBottom, marginTop])
}
